import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const navigate = useNavigate();

  const handleStartEngagement = () => {
    navigate('/best-practice-picker');
  };

  const handleImportBestPractice = () => {
    navigate('/best-practice-picker');
  };

  const handleViewTemplates = () => {
    navigate('/document-generator');
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <h3 className="text-lg font-semibold text-foreground font-inter mb-4">
        Quick Actions
      </h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Button
          variant="default"
          onClick={handleStartEngagement}
          iconName="Plus"
          iconPosition="left"
          className="w-full"
        >
          Start New Engagement
        </Button>
        
        <Button
          variant="outline"
          onClick={handleImportBestPractice}
          iconName="Download"
          iconPosition="left"
          className="w-full"
        >
          Import Best Practice
        </Button>
        
        <Button
          variant="outline"
          onClick={handleViewTemplates}
          iconName="FileTemplate"
          iconPosition="left"
          className="w-full"
        >
          View Templates
        </Button>
      </div>
    </div>
  );
};

export default QuickActions;